import axios from 'axios';
import BaseAPI from './base/base-api';

class InvoiceFilesAPI extends BaseAPI {
    constructor() {
        super();
    }
    urlName = 'InvoiceBotsAPI';
    controllerName = 'invoice-files';

}

export default new InvoiceFilesAPI();